var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgZipAttachment = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2H15.414L20 6.586V20C20 21.103 19.103 22 18 22H6C4.897 22 4 21.103 4 20V4C4 2.898 4.897 2 6 2ZM14 3V8H19L14 3Z",
    fill: "#FFB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29017 18V17.5437L10.1048 14.9975H8.28662V14.3636H11.0707V14.82L9.25431 17.3661H11.0743V18H8.29017ZM12.433 14.3636V18H11.6642V14.3636H12.433ZM13.0656 18V14.3636H14.5002C14.776 14.3636 15.011 14.4163 15.2051 14.5217C15.3993 14.6258 15.5472 14.7708 15.649 14.9567C15.752 15.1413 15.8035 15.3544 15.8035 15.5959C15.8035 15.8374 15.7514 16.0504 15.6472 16.2351C15.5431 16.4197 15.3921 16.5636 15.1945 16.6665C14.998 16.7695 14.76 16.821 14.4807 16.821H13.5663V16.2049H14.3564C14.5044 16.2049 14.6263 16.1795 14.7222 16.1286C14.8192 16.0765 14.8914 16.0049 14.9388 15.9137C14.9873 15.8214 15.0116 15.7154 15.0116 15.5959C15.0116 15.4751 14.9873 15.3698 14.9388 15.2798C14.8914 15.1887 14.8192 15.1183 14.7222 15.0685C14.6251 15.0176 14.502 14.9922 14.3528 14.9922H13.8344V18H13.0656Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgZipAttachment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/zip-attachment.69c091eb.svg";
export { ForwardRef as ReactComponent };